import { type AxiosInstance } from 'axios';
import { type ReactNode } from 'react';

import { type FeatureFlagKey } from '../../constants';
import { useFeatureFlag } from '../../hooks';

interface IFeatureFlagProps {
  flagKey: FeatureFlagKey;
  api: AxiosInstance;
  children: ReactNode;
  fallback: ReactNode;
  loadingComponent: ReactNode;
  errorFallback?: ReactNode;
}

export const FeatureFlag = ({
  flagKey,
  api,
  children,
  fallback,
  loadingComponent,
  errorFallback = null,
}: IFeatureFlagProps): ReactNode => {
  const { isEnabled, isLoading, error } = useFeatureFlag({
    api,
    flagKey,
  });

  if (isLoading) {
    return loadingComponent;
  }

  if (error && errorFallback != null) {
    return errorFallback;
  }

  if (isEnabled) {
    return children;
  }

  return fallback;
};
